import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedEvent: null,
  selectedTicket: null,
  bookedData: null,
  bookingAttributes: [],
};

const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload;
    },
    setSelectedTicket: (state, action) => {
      state.selectedTicket = action.payload;
    },
    setBookingAttributes: (state, action) => {
      state.bookingAttributes = action.payload;
    },
    setEventBookedData: (state, action) => {
      state.bookedData = action.payload;
    },
    resetBookingData: (state) => {
      state.selectedEvent = null;
      state.selectedTicket = null;
      state.bookedData = null;
      state.bookingAttributes = [];
    },
  },
});

export const {
  setSelectedEvent,
  resetBookingData,
  setSelectedTicket,
  setEventBookedData,
  setBookingAttributes,
} = eventsSlice.actions;

export default eventsSlice.reducer;
